import React, { useMemo, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { PrimaryButton } from "../../../components/others/ButtonPrimary";
import { SecundaryButton } from "../../../components/others/ButtonSecundary";
import { validateHoursInterval } from "../../../utils/validateAbsenceTime";
import StyledWrapper from "./style";
import { useModal } from "../../../hooks";

const RequestAbsenceAlertContent = () => {
  const { closeModal } = useModal();
  const { isValid, type, interval } = useMemo(
    () => validateHoursInterval(),
    [],
  );

  useEffect(() => {
    if (isValid) {
      onSubmit();
    }
  }, [isValid]);

  const onSubmit = () => {
    closeModal("modalAlertaSolicitarAusentismo");
    closeModal("modalSolicitarAusentismo");
  };

  return (
    <StyledWrapper.Container>
      <StyledWrapper.Icon>
        <img
          src="/images/HistorialRed.svg"
          alt="Historial"
          width="41"
          color="red"
        />
      </StyledWrapper.Icon>
      <StyledWrapper.Title>
        El horario de recepción de solicitudes es de {interval?.MIN}a{" "}
        {interval?.MAX} hs.
      </StyledWrapper.Title>

      {
        <StyledWrapper.Subtitle>
          Tu solicitud se confirmará dentro de ese horario
        </StyledWrapper.Subtitle>
      }

      <StyledWrapper.Subtitle></StyledWrapper.Subtitle>
      <StyledWrapper.ButtonsContainer>
        {/* <SecundaryButton
          type="submit"
          text="Cancelar solicitud"
          styles="border-transparent font-bold mr-3 text-lav-black-text bg-opacity-10 bg-red-400 text-red-400 hover:bg-opacity-20"
          onClick={onSubmit}
        /> */}
        <PrimaryButton
          type="submit"
          text="De acuerdo"
          styles="bg-red-400 text-white font-bold hover:bg-opacity-80"
          onClick={onSubmit}
        />
      </StyledWrapper.ButtonsContainer>
    </StyledWrapper.Container>
  );
};

export default RequestAbsenceAlertContent;
